import React from "react";


const Blank = ()=>{
    return(
        <></>
    )
}

export default Blank;